// extracted by mini-css-extract-plugin
export default {"icon":"ZAGJA","appear-from-above":"wbAji","appearFromAbove":"wbAji"};